import React from 'react';
import ReactDOM from 'react-dom';


var button = {
    border: "none",
    borderRadius: "40px",
    background: "#292b2e",
    color: "#f9f9f9",
    padding: "10px 37px",
    margin: "10px 0 20px 60px",
}
export default class maps extends React.Component {
    constructor() {
        super();
        this.state = {
            center: { lat: 59.95, lng: 30.33 },
            zoom: 11,
            tab: "plus"
        }
    }

    render() {
        return (
            <div className="promos">
                <div className={this.state.tab === "premium" ? "promo scale" : "promo"} onClick={() => this.setState({ tab: "premium" })}>
                    <div className="deal">
                        <span>Standard</span>
                        <span>Crea tus propios checklists</span>
                    </div>
                    <span className="price">USD $ 25</span>
                    <ul className="features" style={{ textAlign: "center" }}>
                        <li>Compatible iOS/Android
                            Modo Offline/Online
                            Perfiles usuario
                            Fotografías con sello de
                            agua
                            Captura ilimitada datos
                            Resultados tiempo real
                            Documentación en línea
                        </li>
                    </ul>
                    <a href="https://www.operatio.cl/standard" target="_blank"> <button style={button} >Inscribete</button></a>
                </div>
                <div className={this.state.tab === "plus" ? "promo scale" : "promo"} onClick={() => this.setState({ tab: "plus" })}>
                    <div className="deal">
                        <span>Premium</span>
                        <span>Gráficos y soluciones empaquetadas</span>
                    </div>
                    <span className="price">USD $ 35</span>
                    <ul className="features" style={{ textAlign: "center" }}>
                        <li>Plan Standard, y además
                            incluye:
                            Plantillas personalizadas por
                            áreas de negocios
                            Alertas en tiempo real
                            Dashboard gráficos
                            Resultados en tiempo real
                            Soporte Chat
                        </li>
                    </ul>
                    <a href="https://www.operatio.cl/premium" target="_blank"> <button style={button} >Inscribete</button></a>
                </div>
                <div className={this.state.tab === "basic" ? "promo scale" : "promo"} onClick={() => this.setState({ tab: "basic" })}>
                    <div className="deal">
                        <span>Enterprise</span>
                        <span>Soluciones a la medida</span>
                    </div>
                    <span className="price">Contáctanos</span>
                    <ul className="features" style={{ textAlign: "center" }}>
                        <li>
                            Integración con plataformas
                            Gráficos personalizados
                            Levantamiento de datos en
                            terreno con personal
                            contratado
                            Soporte especializado
                            Envíanos tus solicitud
                        </li>
                    </ul>
                    <a href="https://www.operatio.cl/enterprise" target="_blank"> <button style={button} >Contáctanos</button></a>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/dashBoard/pricingTables.js